import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthStore } from '../../stores/auth.store';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(AuthStore);
  const clonedReq = req.clone({
    headers: req.headers.set('Authorization', `Bearer ${store.authInfo()?.token}`)
  });
  return next(clonedReq);
};
